/**
 * Recruited positions a JD is tagged with; position-based CV reviewers (team leads, CTO for BrSE,
 * CEO for Sales...) are matched on them. Keep in sync with backend src/shared/cv-positions.ts.
 */
export const CV_POSITIONS = [
  { value: 'DATA_ENGINEER', label: 'Data Engineer' },
  { value: 'AI_ENGINEER', label: 'AI Engineer' },
  { value: 'AI_INFRA_ENGINEER', label: 'AI Infra Engineer' },
  { value: 'BRSE', label: 'BrSE' },
  { value: 'WEB_ENGINEER', label: 'Web Engineer' },
  { value: 'IT_COMTOR', label: 'IT Comtor' },
  { value: 'TESTER', label: 'Tester' },
  { value: 'DATA_ANALYST', label: 'Data Analyst' },
  { value: 'IT_HELPDESK', label: 'IT Helpdesk' },
  { value: 'ACCOUNTANT', label: 'Accountant' },
  { value: 'HR', label: 'HR' },
  { value: 'SALES', label: 'Sales' },
  { value: 'SALES_SUPPORT', label: 'Sales support' },
  { value: 'OTHER', label: 'Other' },
] as const;

export type CvPosition = (typeof CV_POSITIONS)[number]['value'];

export const getCvPositionLabel = (value?: string | null) =>
  CV_POSITIONS.find((position) => position.value === value)?.label ?? '';
